import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../services/metaPixel";

/** The site changes pages without reloading, so report each route change. */
const MetaPixelPageViews = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageView();
  }, [pathname]);
  return null;
};

export default MetaPixelPageViews;
